import React, { Component, useDebugValue } from "react";
import {
  Form,
  FormGroup,
  FormFeedback,
  Col,
  Label,
  Input,
  Button,
  Row,
  CustomInput,
  Popover,
  PopoverHeader,
  PopoverBody,
} from "reactstrap";
import { kpiBasedType, chartStep } from "../../../../utils/constants";
import {
  getBenchmarkData,
  filterBenchmarkByState,
} from "../../../../utils/filterKpisData";
import Tooltip from "../../../../components/UI/TooltipIcon/TooptipIcon";
import ErrorMessage from "../../../../components/Message/ErrorMessage/ErrorMessage";
import ChartPreview from "../ChartPreview/ChartPreview";
import "../Component.css";
import axios from "../../../../axios";
import Toggle from "react-toggle";
import "react-toggle/style.css";
import Select from "react-select";
import * as url from "../../../../utils/url";

export default class ChartPrivacy extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: {
        value: this.props.chartDetails.name,
        // value: localStorage.getItem('chartNavigationFlow')!==null && localStorage.getItem('chartNavigationFlow') === 'recreate' ? 'Copy of ' + this.props.chartDetails.name : this.props.chartDetails.name,
        error: false,
      },
      newUserAdded: null,
      privacy:
        this.props.chartDetails.privacy !== ""
          ? this.props.chartDetails.privacy
          : "PRIVATE",
      permission:
        this.props.chartDetails.permission !== ""
          ? this.props.chartDetails.permission
          : "VIEW",
      isPrivacySettingsChanged: false,
      error: false,
      errorMessage: "",
      displayUsers: [],
      yAxisFormat: this.props.chartDetails.yAxisFormat
        ? this.props.chartDetails.yAxisFormat
        : "",
      isUserList:
        (this.props.chartDetails.invitedUsers &&
          this.props.chartDetails.invitedUsers.length > 0) ||
        this.props.chartDetails.privacy === "CUSTOM"
          ? true
          : false,
      invitedUsers:
        this.props.chartDetails.invitedUsers &&
        this.props.chartDetails.invitedUsers.length > 0
          ? this.props.chartDetails.invitedUsers
          : [],
      privacyPopoverOpen: false,
      permissionPopoverOpen: false,
      filteredBenchmarkData: null,
    };
  }
  componentWillUnmount() {
    this.state = {};
  }

  setFilteredBenchmarkData = () => {
    // let benchmarkData = null;
    let {
      selectedBenchmarkData,
      kpiAgreegateData,
      startDate,
      kpiBenchmarkData,
      endDate,
      useLatestDataAvailable,
      benchmarkData,
    } = this.props.chartDetails;
    // console.log(this.props.chartDetails)

    if (
      selectedBenchmarkData !== null &&
      benchmarkData !== "undefined" &&
      benchmarkData !== undefined &&
      kpiBenchmarkData.length > 0
    ) {
      // console.log('benchmmm')
      let { benchmarkLocation } = this.props.chartDetails;
      // console.log(this.props)
      selectedBenchmarkData = filterBenchmarkByState(
        kpiBenchmarkData,
        benchmarkLocation.state.name
      );
      benchmarkData = getBenchmarkData(
        { selectedBenchmark: selectedBenchmarkData, kpiAgreegateData },
        true,
        { startDate, endDate, useLatestDataAvailable }
      );
      // console.log(benchmarkData, '--------',selectedBenchmarkData)
      if (
        benchmarkData &&
        benchmarkData.score &&
        benchmarkData.score.length > 0
      ) {
        this.setState({
          filteredBenchmarkData: benchmarkData,
          selectedBenchmarkData,
          benchmarkData: selectedBenchmarkData,
        });
      }
    } else {
      selectedBenchmarkData = [];
      this.setState({
        filteredBenchmarkData: selectedBenchmarkData,
        selectedBenchmarkData,
      });
      // this.props.onCompleted({...selectedBenchmarkData})
    }
  };

  componentDidMount() {
    window.scrollTo(0, 0);
    if (
      this.props.chartDetails.createdBy &&
      this.props.chartDetails.createdBy._id &&
      this.props.chartDetails.createdBy._id === this.props.user._id
    ) {
      if (this.state.isUserList || this.state.privacy === "CUSTOM") {
        this.getUserList();
      }
    }
    // this.setFilteredBenchmarkData();
  }

  // componentWillReceiveProps(nextProps) {
  //   console.log('WILL')
  // }

  // // Handle condtion to show preselect kpis if case of edit chart
  // componentDidUpdate(prevProps, prevState, snapshot){
  //   console.log('UPDATE')
  // }

  deleteTempStateValues = localState => {
    delete localState.error;
    delete localState.errorMessage;
    delete localState.selectedPrivacy;
    delete localState.selectedPermission;
    delete localState.privacyPopoverOpen;
    delete localState.permissionPopoverOpen;
    delete localState.filteredBenchmarkData;
    return localState;
  };

  handleChartNameChange = event => {
    // if (event.key === 'Enter')
    this.setState({ name: { value: event.target.value, error: false } });
  };

  getUserList = () => {
    let { displayUsers } = this.state;
    if (displayUsers.length === 0) {
      axios
        .get(url.userListArray)
        .then(response => {
          const users = response.data && response.data.data && response.data.data.emailUsers ? response.data.data.emailUsers : [];
          this.setState({
            displayUsers: users.map(e => {
              if (e.firstName && e.lastName) {
                return {
                  label: `${e.firstName} ${e.lastName}`,
                  value: e._id,
                  permissions: 0,
                };
              } else if (e.firstName || e.lastName) {
                let name =
                  e.firstName && e.firstName.length > 0
                    ? e.firstName
                    : e.lastName;
                return { label: `${name}`, value: e._id, permissions: 0 };
              } else {
                return { label: `${e.email}`, value: e._id, permissions: 0 };
              }
            }).filter(Boolean),
          });
        })
        .catch(error => {
          console.log(error);
        });
    }
  };

  handleOptionChange = changeEvent => {
    // console.log(changeEvent.target)
    let permission = "";
    if (changeEvent.target.value === "ENTERPRISE") {
      permission = "VIEW";
      this.setState({
        privacy: changeEvent.target.value,
        permission,
        invitedUsers: [],
        isUserList: false,
      });
    } else if (changeEvent.target.value === "CUSTOM") {
      this.setState({
        isUserList: true,
        privacy: "CUSTOM",
      });
      this.getUserList();
    } else {
      this.setState({
        privacy: changeEvent.target.value,
        permission: "VIEW",
        invitedUsers: [],
        isUserList: false,
      });
    }
  };

  handlePermissionChange = () => {
    let permission = this.state.permission === "EDIT" ? "VIEW" : "EDIT";
    this.setState({ permission: permission });
  };

  validateChartDetails = () => {
    let { name, privacy, filteredBenchmarkData, invitedUsers, yAxisFormat } =
      this.state;
    let { kpiData, kpiType, allOfficeKeys, selectedOffice } =
      this.props.chartDetails;
    // let {allOfficeKeys} = this.props
    let filteredKpiData = kpiData.filter(kpi => kpi.score);
    if (kpiType === kpiBasedType.empDataBased) {
      if (filteredBenchmarkData === null && filteredKpiData.length === 0) {
        this.setState({
          error: true,
          errorMessage:
            "Please select start and end dates for a time period which has existing Key Performance Indicators or benchmark data.",
        });
        window.scrollTo(0, 0);
        return;
      }
    } else if (
      kpiType === kpiBasedType.empDataBased &&
      filteredKpiData.length === 0
    ) {
      this.setState({
        error: true,
        errorMessage: "Chart must have at least one point of kpi data.",
      });
      window.scrollTo(0, 0);
      return;
    }
    console.log(privacy, invitedUsers);

    if (privacy === "CUSTOM" && invitedUsers.length == 0) {
      this.setState({
        error: true,
        errorMessage: "Please select users you want to share this chart with.",
      });
      return;
    }
    const title = name.value;
    if (!title || title.trim() === "") {
      this.setState({ name: { name: title, error: true } });
    } else if (privacy === "") {
      this.setState({
        error: true,
        errorMessage: "Please choose privacy settings.",
      });
    } else {
      let localState = { ...this.state };
      localState.isPrivacySettingsChanged = true;
      localState = this.deleteTempStateValues(localState);
      localState.name = localState.name.value;
      localState.allOfficeKeys = allOfficeKeys;
      localState.selectedOffice = selectedOffice;
      if (invitedUsers.length > 0) {
        localState.invitedUsers = invitedUsers;
      }
      this.props.onCompleted({ ...localState, yAxisFormat });
    }
  };

  goToPreviousStep = () => {
    this.props.goBackToPreviousStep();
  };

  // Toggle popover
  togglePrivacySettings = () => {
    this.setState({
      privacyPopoverOpen: !this.state.privacyPopoverOpen,
      permissionPopoverOpen: false,
    });
  };

  togglePersmission = () => {
    this.setState({
      permissionPopoverOpen: !this.state.permissionPopoverOpen,
      privacyPopoverOpen: false,
    });
  };

  isDisabledEdit = () => {
    if (
      this.props.chartDetails.createdBy &&
      this.props.chartDetails.createdBy._id
    ) {
      if (
        this.props.user._id === this.props.chartDetails.createdBy._id ||
        this.props.user.role === "Admin"
      ) {
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  };

  onUserSelect = u => {
    console.log(u);
    if (u && u.length != 0) {
      u.date = Date.now();
      u.isoDate = new Date().toISOString();
      u[u.length - 1].permissions = 0;
      this.setState({ invitedUsers: u, error: false });
    } else {
      this.setState({ invitedUsers: [] });
    }
  };

  onUserSetPermissions = (p, u) => {
    // console.log(p, u)
    let { invitedUsers } = this.state;
    if (p && p != null && p != undefined) {
      invitedUsers.forEach((item, index) => {
        if (item.value == u.value) invitedUsers[index].permissions = p.value;
      });
      this.setState({ invitedUsers });
    } else {
      invitedUsers.forEach((item, index) => {
        if (item.value == u.value)
          invitedUsers[index].permissions = { label: "View", value: 0 };
      });
      this.setState({ invitedUsers });
    }
  };

  yAxisFormat = val => {
    this.setState({ yAxisFormat: val });
  };

  privacyContent = type => {
    let {
      filteredBenchmarkData,
      isUserList,
      privacy,
      newUserAdded,
      invitedUsers,
      displayUsers,
    } = this.state;

    if (type === "enable") {
      return (
        <div>
          <Row>
            <Col>
              <div className="radio ml0 mt0">
                <input
                  id="meRadio"
                  name="meRadio"
                  onChange={this.handleOptionChange}
                  type="radio"
                  value="PRIVATE"
                  checked={privacy === "PRIVATE"}
                />
                <label
                  htmlFor="meRadio"
                  className="radio-label benchmark-radio-label benchmark-display-name"
                >
                  Me
                </label>
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              <div className="radio ml0 mt5">
                <input
                  id="enterpriseRadio"
                  name="enterpriseRadio"
                  onChange={this.handleOptionChange}
                  type="radio"
                  value="ENTERPRISE"
                  checked={privacy === "ENTERPRISE"}
                />
                <label
                  htmlFor="enterpriseRadio"
                  className="radio-label benchmark-radio-label benchmark-display-name"
                >
                  Enterprise
                </label>
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              <div className="radio ml0 mt5">
                <input
                  id="customRadio"
                  name="customRadio"
                  onChange={this.handleOptionChange}
                  type="radio"
                  value="CUSTOM"
                  checked={privacy === "CUSTOM"}
                />
                <label
                  htmlFor="customRadio"
                  className="radio-label benchmark-radio-label benchmark-display-name"
                >
                  Invite Specific Users
                </label>
              </div>
            </Col>
          </Row>
        </div>
      );
    } else {
      return <span className="chart-privacy-label">{privacy}</span>;
    }
  };

  renderPrivacyOptions = () => {
    let { chartDetails, user, isCopied } = this.props;
    if (chartDetails && chartDetails.createdBy && chartDetails.createdBy._id) {
      if (chartDetails.createdBy._id === user._id) {
        return this.privacyContent("enable");
      } else if (isCopied) {
        return this.privacyContent("enable");
      } else {
        return this.privacyContent("disable");
      }
    } else {
      return this.privacyContent("enable");
    }
  };

  render() {
    // console.log(this.props.chartDetails)
    let { chartDetails } = this.props;
    let {
      filteredBenchmarkData,
      isUserList,
      privacy,
      newUserAdded,
      invitedUsers,
      displayUsers,
      
    } = this.state;
    let { industriesList, user ,isChartLocked} = this.props;
    let alert = null;
    if (this.state.error) {
      alert = <ErrorMessage message={this.state.errorMessage} />;
    }

    // console.log(this.props, this.state.isUserList)
    return (
      <Form>
        {alert}
        <FormGroup row>
          <Col sm={3} md={3} lg={3}>
            <div className="float-right chart-name-label">Title</div>
          </Col>
          <Col sm={8} className="align-self-center">
            <div className="inner-addon right-addon">
              {/* <span className="name-hint-max-length name-char-count-txt">
                {this.state.name.value ? this.state.name.value.length : 0 }/64
              </span> */}
              <Input
                type="text"
                name="chartTitle"
                className="input-custom"
                value={this.state.name.value}
                id="chartTitle"
                // maxLength="64"
                onChange={this.handleChartNameChange}
                onKeyPress={e => {
                  e.key === "Enter" && e.preventDefault();
                }}
                placeholder="Write a short distinct name for a new chart"
                invalid={this.state.name.error}
              />
            </div>
            {this.state.name.error ? (
              <div className="input-error-msg-field">
                Please enter a title for the chart.
              </div>
            ) : null}
          </Col>
        </FormGroup>
        <FormGroup
          className={
            this.props.isOwner ? "disabled-change-privacy mt40" : "mt40"
          }
          row
        >
          <Col sm={3} md={3} lg={3}>
            <div className="float-right">
              <span
                id="privacy-settings-popover"
                style={{ marginRight: "10px" }}
                onClick={this.togglePrivacySettings}
              >
                <Tooltip />
              </span>
              <span className="chart-privacy-label float-right">
                Privacy setting
              </span>
              <Popover
                placement="left"
                isOpen={this.state.privacyPopoverOpen}
                target="privacy-settings-popover"
                toggle={this.togglePrivacySettings}
              >
                <PopoverHeader className="popover-header-tooltip">
                  Privacy Settings
                </PopoverHeader>
                <PopoverBody className="popover-body-tooltip">
                  Select “Only me” to make this chart completely private; so no
                  one else will be able to view or edit it. If you would like to
                  share it with other users in your office, select “Me and my
                  office.” If you would like to share it with users in all
                  offices in your organizational chain of command, select “Me,
                  my office and offices below me.
                </PopoverBody>
              </Popover>
            </div>
          </Col>
          <Col sm={8} md={8} lg={8}>
            {this.renderPrivacyOptions()}
          </Col>
        </FormGroup>
        {this.state.privacy === "ENTERPRISE" ? (
          <FormGroup
            className={
              this.props.isOwner ? "disabled-change-permission mt40" : "mt40"
            }
            row
          >
            <Col sm={3} md={3} lg={3}>
              <div className="float-right">
                <span
                  id="permission-popover"
                  style={{ marginRight: "10px" }}
                  onClick={this.togglePersmission}
                >
                  <Tooltip />
                </span>
                <span className="chart-permission-label float-right">
                  Permissions
                </span>
                <Popover
                  placement="left"
                  isOpen={this.state.permissionPopoverOpen}
                  target="permission-popover"
                  toggle={this.togglePersmission}
                >
                  <PopoverHeader className="popover-header-tooltip">
                    Permissions
                  </PopoverHeader>
                  <PopoverBody className="popover-body-tooltip">
                    Toggle from “View Only” to “View and Edit” to allow others
                    you have shared this chart with, to make modifications to
                    it. Note, you can always change the privacy settings and
                    permissions again and/or at a later time.
                  </PopoverBody>
                </Popover>
              </div>
            </Col>
            <Col sm={8} md={8} lg={8}>
              <div className="align-items-center">
                <span className="permission-value">View Only</span>
                <span className="ml10">
                  <Toggle
                    defaultChecked={this.state.permission === "EDIT"}
                    icons={false}
                    onChange={this.handlePermissionChange}
                    disabled={isChartLocked}
                  />
                </span>
                <span className="permission-value ml10">View And Edit</span>
              </div>
            </Col>
          </FormGroup>
        ) : null}

        {isUserList === true ? (
          <FormGroup
            className={
              this.props.isOwner ? "disabled-change-permission mt40" : "mt40"
            }
            row
          >
            <Col sm={3} md={3} lg={3}>
              <div className="float-right">
                <span
                  id="permission-popover"
                  style={{ marginRight: "10px" }}
                  onClick={this.togglePersmission}
                >
                  <Tooltip />
                </span>
                <span className="chart-permission-label float-right">
                  {this.props.chartDetails.createdBy &&
                  this.props.chartDetails.createdBy._id &&
                  this.props.chartDetails.createdBy._id ===
                    this.props.user._id ? (
                    <span>Share With</span>
                  ) : (
                    <span>Shared with</span>
                  )}
                </span>
                <Popover
                  placement="left"
                  isOpen={this.state.permissionPopoverOpen}
                  target="permission-popover"
                  toggle={this.togglePersmission}
                >
                  <PopoverHeader className="popover-header-tooltip">
                    {" "}
                    Sharing{" "}
                  </PopoverHeader>
                  <PopoverBody className="popover-body-tooltip">
                    Selects users you would like to share this chart with.
                  </PopoverBody>
                </Popover>
              </div>
            </Col>
            <Col sm={8} md={8} lg={8}>
              <FormGroup className="" row>
                <Col sm={2} className="">
                  <div className="chartLabel">Select Users</div>
                </Col>
                <Col sm={6} md={6} className="align-self-center">
                  <Select
                    isMulti={true}
                    multi={true}
                    name="user-select"
                    placeholder={"Select users to share this chart with"}
                    value={invitedUsers.length > 0 ? invitedUsers : ""}
                    isOpen={true}
                    options={displayUsers}
                    onChange={itm => this.onUserSelect(itm)}
                    className="basic-multi-select"
                    classNamePrefix="select"
                  />
                </Col>
              </FormGroup>
              {invitedUsers.length > 0
                ? invitedUsers.map(e => {
                    return (
                      <div key={e.value}>
                        <Row className="mb10">
                          <Col sm={2} md={2} className="align-self-center">
                            <span>{e.label}</span>
                          </Col>
                          <Col sm={6} md={6} className="align-self-center">
                            <Select
                              isClearable={false}
                              name="permission-select"
                              placeholder={"Select a permission/privacy"}
                              value={e.permissions}
                              isOpen={true}
                              options={[
                                { label: "View", value: 0 },
                                { label: "Edit", value: 1 },
                              ]}
                              onChange={itm =>
                                this.onUserSetPermissions(itm, e)
                              }
                              className="basic-multi-select"
                              classNamePrefix="select"
                            />
                          </Col>
                        </Row>
                      </div>
                    );
                  })
                : null}
            </Col>
          </FormGroup>
        ) : null}

        <FormGroup className="mt40" row>
          <Col sm={{ size: 3 }}>
            <Button
              className="float-left goBackBtn w100"
              onClick={this.goToPreviousStep}
            >
              <span className="goBackBtnTxt">
                <span className="mr10 flaticon-back"></span> Go Back
              </span>
            </Button>
          </Col>
          <Col sm={{ size: 3, offset: 5 }} className="col-md-offset-right-1">
            <Button
              className="float-right continueBtn ml10 w100"
              onClick={this.validateChartDetails}
              type="button"
            >
              <span className="continueBtnTxt">
                {this.props.chartDetails._id ? "Submit" : "Create"}
                <span className="ml10 flaticon-tick"></span>
              </span>
            </Button>
          </Col>
        </FormGroup>
        {/* <Row className="mt40 mb20">
          <Col sm={11} md={11}>
          <ChartPreview
            isChartPrivacy={true}
            chartDetails={this.props.chartDetails}
            kpiData={[...this.props.chartDetails.kpiData]}
            yAxisFormat={this.yAxisFormat}
          
            benchmarkData={filteredBenchmarkData}
            startDate={this.props.chartDetails.startDate}
            endDate={this.props.chartDetails.endDate}
            useLatestDataAvailable={this.props.chartDetails.useLatestDataAvailable}
            name={this.state.name.value}
            privacy={this.state.privacy}
            step={chartStep.privacy}
            industriesList={industriesList}
            user={user}
            benchmarkLocation = {this.props.chartDetails.benchmarkLocation}
          />
         
          </Col>
        </Row> */}
      </Form>
    );
  }
}
